import script from "./MobileDispatchCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileDispatchCreate.vue?vue&type=script&setup=true&lang=js"

import "./MobileDispatchCreate.vue?vue&type=style&index=0&id=5d4fb714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d4fb714"]])

export default __exports__